export default __webpack_public_path__ + "static/media/x-circle.557dd3e1.svg";